<nav class="mobile-tapbar">
  <ng-container *ngIf="role$ | async as role">
    <button mat-button 
      [routerLink]="['/private/profile']"
      routerLinkActive="router-link-active"
    >
      <mat-icon>person</mat-icon>
      <!-- <span>Профиль</span> -->
    </button>

    <button
      mat-button
      [routerLink]="['/private/events']"
      routerLinkActive="router-link-active"
    >
      <mat-icon>search</mat-icon>
      <!-- <span>Мероприятия</span> -->
    </button>

    @if (role == 'teacher') {
    <!-- <button
      mat-button
      [routerLink]="['/private/my-events']"
      routerLinkActive="router-link-active"
    >
      <mat-icon>add</mat-icon>
    </button> -->
    <div class="hide-button"></div>
    <div
      class="add-button"
      [routerLink]="['/private/my-events']"
      routerLinkActive="router-link-active"
    >
      <mat-icon>add</mat-icon>
    </div>
    }

    <button mat-button 
      [routerLink]="['/private/requests']"
      routerLinkActive="router-link-active"
    >
      <mat-icon>exit_to_app</mat-icon>
      <!-- <span>Мои заявки</span> -->
    </button>

    <button
      mat-button
      [routerLink]="['/private/calendar']"
      routerLinkActive="router-link-active"
    >
      <mat-icon>calendar_month</mat-icon>
      <!-- <span>Мое расписание</span> -->
    </button>

    <!-- <ng-container *ngIf="role == 'student'; else teacher">
      <button
        mat-button
        [routerLink]="['/private/teachers']"
        routerLinkActive="router-link-active"
      >
        <mat-icon>school</mat-icon>
      </button>
    </ng-container>
    <ng-template #teacher>
      <button
        mat-button
        [routerLink]="['/private/settings']"
        [queryParams]="{ tab: 'myevents' }"
        routerLinkActive="router-link-active"
      >
        <mat-icon>calendar_month</mat-icon>
        <span>Мои мероприятия</span>
      </button>
    </ng-template> -->
  </ng-container>
</nav>
